import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-applicant-info.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-applicant-info.component.scss?ngResource";
import { Component } from "@angular/core";
import { ApplicationSearchConstants } from "../application-search-constants";
import { FormControl, FormGroup } from "@angular/forms";
import { Subject, take } from "rxjs";
import { ApplicationSearchService } from "../../shared/application-search.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../app-controller.service";
import { Store } from "@ngrx/store";
import { takeUntil } from "rxjs/operators";
import { AutoUnsub } from "../../../../shared/decorators/autounsub.decorator";
let SearchApplicantInfoComponent = class SearchApplicantInfoComponent {
    applicationSearchService;
    aflaModuleStrategyService;
    appController;
    store;
    _destroy$ = new Subject();
    applicantInfoNameLabel = ApplicationSearchConstants.FORM_CONTROLS.nameLabel;
    applicantInfoSurnameLabel = ApplicationSearchConstants.FORM_CONTROLS.surnameLabel;
    applicantInfoOrganisationLabel = ApplicationSearchConstants.FORM_CONTROLS.organisationLabel;
    applicantInfoNameFormControl = ApplicationSearchConstants.FORM_CONTROLS.nameFormControl;
    applicantInfoSurnameFormControl = ApplicationSearchConstants.FORM_CONTROLS.surnameFormControl;
    applicantInfoOrganisationFormControl = ApplicationSearchConstants.FORM_CONTROLS.organisationFormControl;
    searchText = ApplicationSearchConstants.FORM_CONTROLS.searchText;
    applicantInfoForm;
    tabChanged;
    applicationSearchCallback;
    constructor(applicationSearchService, aflaModuleStrategyService, appController, store) {
        this.applicationSearchService = applicationSearchService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
        this.store = store;
    }
    ngOnInit() {
        this.setUpForm();
    }
    searchApplication($event) {
        const apps = this.store.select("applicationFormGroup");
        const tabSwitched = this.store.select("applicationTabChanged");
        tabSwitched.pipe(takeUntil(this._destroy$), take(1)).subscribe({
            next: (tab) => {
                this.tabChanged = tab;
            }
        });
        apps.pipe(takeUntil(this._destroy$), take(1)).subscribe(val => {
            if (val != null && this.tabChanged) {
                this.applicantInfoForm = val;
            }
        });
        this.tabChanged = false;
        const name = this.applicantInfoForm.get(this.applicantInfoNameFormControl).value;
        const surname = this.applicantInfoForm.get(this.applicantInfoSurnameFormControl).value;
        const organisation = this.applicantInfoForm.get(this.applicantInfoOrganisationFormControl).value;
        if (!this.tabChanged) {
            this.applicationSearchCallback(this.applicationSearchService.searchByApplicantInfo(name, surname, organisation, this.aflaModuleStrategyService, Number(this.appController.selectedModuleID)));
        }
    }
    setUpForm() {
        this.applicantInfoForm = new FormGroup({
            nameFormControl: new FormControl(""),
            surnameFormControl: new FormControl(""),
            organisationFormControl: new FormControl("")
        });
    }
    static ctorParameters = () => [
        { type: ApplicationSearchService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService },
        { type: Store }
    ];
};
SearchApplicantInfoComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-search-applicant-info",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], SearchApplicantInfoComponent);
export { SearchApplicantInfoComponent };
